{
  "action": {
    "ok": "OK",
    "cancel": "Abbrechen",
    "save": "Speichern",
    "saved": "Gespeichert",
    "close": "Schließen",
    "yes": "Ja",
    "no": "Nein",
    "delete": "Löschen",
    "remove": "Entfernen",
    "add": "Hinzufügen",
    "edit": "Bearbeiten",
    "rename": "Umbenennen",
    "retry": "Erneut versuchen",
    "reset": "Zurücksetzen",
    "apply": "Anwenden",
    "confirm": "Bestätigen",
    "back": "Zurück",
    "next": "Weiter",
    "done": "Fertig",
    "refresh": "Aktualisieren",
    "copy": "Kopieren",
    "copied": "Kopiert",
    "open": "Öffnen",
    "start": "Starten",
    "stop": "Stopp",
    "pause": "Pausieren",
    "resume": "Fortsetzen",
    "continue": "Weiter",
    "clear": "Leeren",
    "search": "Suchen",
    "loading": "Lädt…",
    "saving": "Wird gespeichert…",
    "searchPlaceholder": "Suchen…",
    "always": "Immer",
    "deny": "Ablehnen",
    "undo": "Rückgängig",
    "all": "Alle"
  },
  "confirm": {
    "title": "Freigabe erforderlich: {{tool}}",
    "descriptionEdit": "Der Agent möchte eine Datei ändern. Überprüfe die Anfrage unten und entscheide, ob du fortfahren möchtest.",
    "descriptionTool": "Der Agent möchte dieses Tool ausführen. Überprüfe die Anfrage unten und entscheide, ob du fortfahren möchtest.",
    "fileModification": "Dateiänderung",
    "toolExecution": "Tool-Ausführung",
    "riskSuffix": "{{risk}} Risiko",
    "command": "Befehl",
    "inputLabel": "Eingabe:",
    "trustSuggestionTitle": "Vorschlag für Vertrauensmuster",
    "trustSuggestionHint": "Wenn du Immer wählst, werden übereinstimmende Aufrufe für dieses Projekt auf die Whitelist gesetzt.",
    "yoloDestructiveNote": "YOLO ist aktiv. Diese Abfrage wird trotzdem angezeigt, da die Anfrage als destruktiv eingestuft wurde.",
    "skipApprovalsTitle": "Zukünftige Freigaben überspringen",
    "skipApprovalsHint": "Aktiviere den YOLO-Modus und der Agent läuft ohne Nachfrage. Destruktive Vorgänge fragen weiterhin nach.",
    "enableYoloTitle": "YOLO-Modus aktivieren (diesen und zukünftige nicht-destruktive Aufrufe automatisch freigeben)",
    "enableYoloBtn": "YOLO aktivieren",
    "denyAlways": "Immer ablehnen",
    "denyAlwaysTitle": "Diesen und alle zukünftigen, zum Muster passenden Aufrufe ablehnen (d)",
    "noTitle": "Diesen einzelnen Aufruf ablehnen (Esc / n)",
    "alwaysTitle": "Freigeben und das Muster für das Projekt speichern (a)",
    "yesTitle": "Diesen einzelnen Aufruf freigeben (y)"
  },
  "status": {
    "connected": "Verbunden",
    "disconnected": "Getrennt",
    "connecting": "Verbindung wird hergestellt…",
    "reconnecting": "Verbindung wird wiederhergestellt…",
    "ready": "Bereit",
    "error": "Fehler",
    "offline": "Offline",
    "online": "Online",
    "live": "Live",
    "budgetWarning": "Budget-Warnung",
    "running": "Läuft",
    "inProgress": "In Arbeit",
    "working": "arbeitet"
  },
  "time": {
    "justNow": "gerade eben",
    "secondsAgo_one": "vor {{count}} Sekunde",
    "secondsAgo_other": "vor {{count}} Sekunden",
    "minutesAgo_one": "vor {{count}} Minute",
    "minutesAgo_other": "vor {{count}} Minuten",
    "hoursAgo_one": "vor {{count}} Stunde",
    "hoursAgo_other": "vor {{count}} Stunden",
    "daysAgo_one": "vor {{count}} Tag",
    "daysAgo_other": "vor {{count}} Tagen",
    "compactSecondsAgo": "vor {{count}} s",
    "compactMinutesAgo": "vor {{count}} min",
    "compactHoursAgo": "vor {{count}} Std."
  },
  "error": {
    "title": "Etwas ist schiefgelaufen",
    "body": "Ein Render-Fehler ist aufgetreten. Deine Sitzung ist auf dem Server noch aktiv — Neuladen setzt dort fort, wo du aufgehört hast.",
    "reload": "Seite neu laden",
    "tryAgain": "Erneut versuchen"
  },
  "sparkline": {
    "noActivity": "Keine Aktivität",
    "noActivityYet": "Noch keine Aktivität",
    "activityMax": "Aktivitäts-Sparkline: max. {{count}} Ereignisse",
    "activityPeak": "Aktivitäts-Sparkline — Spitze {{count}} Ereignisse/Intervall"
  }
}
